import { httpClient } from "@/services";

export default {
	state: {
		settingsCompanies: [],
		companiesCompanies: [],
		filtersCompanies: {},
		editCompanies: {},
	},
	mutations: {
		updateCompanies(state, { settings, items, filters }) {
			state.settingsCompanies = settings;
			state.companiesCompanies = items;
			state.filtersCompanies = filters;
		},
		updateEditCompanies(state, { company }) {
			state.editCompanies = company;
		},
	},
	actions: {

		async deleteAccountCompanies({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/company/${ id }`);
				if (data && data.status) {
					dispatch('getAccountCompaniesList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountCompaniesList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/company");
				if (data) {
					commit('updateCompanies', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountCompaniesEdit({ commit, dispatch }, args ) {
			try {
				const { id, sendInfo } = args;
				const { data } = await httpClient.put(`/info/company/${ id }`, sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountCompaniesSave({ commit, dispatch }, args) {
			try {
				const { sendInfo } = args;
				const { data } = await httpClient.post("/info/company", sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}

		},

		async getAccountCompaniesEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/company/${ id }/edit`);
				if (data && data.status) {
					commit('updateEditCompanies', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}

		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editCompanies: s => s.editCompanies,
		settingsCompanies: s => s.settingsCompanies,
		companiesCompanies: s => s.companiesCompanies,
		filtersCompanies: s => s.filtersCompanies,
	},
};
